'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _dec, _class2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = require('react-redux');

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _components = require('components');

var _subscriptions = require('redux/modules/subscriptions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserSubscription = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(UserSubscription, _React$Component);

  function UserSubscription(props) {
    (0, _classCallCheck3.default)(this, UserSubscription);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UserSubscription.__proto__ || (0, _getPrototypeOf2.default)(UserSubscription)).call(this, props));

    _this.state = {
      autoRenew: props.subscription == undefined ? null : props.subscription.autoRenew
    };
    return _this;
  }

  (0, _createClass3.default)(UserSubscription, [{
    key: 'onTopupClick',
    value: function onTopupClick() {
      this.context.dialogs.custom(_react2.default.createElement(_components.TopupDialog, null));
    }
  }, {
    key: 'onRestartSubscriptionClick',
    value: function onRestartSubscriptionClick() {
      this.context.dialogs.custom(_react2.default.createElement(_components.RestartSubscriptionDialog, null));
    }
  }, {
    key: 'onCancelSubscriptionClick',
    value: function onCancelSubscriptionClick() {
      this.context.dialogs.custom(_react2.default.createElement(_components.CancelSubscriptionDialog, null));
    }
  }, {
    key: 'onChangePaymentDetailsClick',
    value: function onChangePaymentDetailsClick() {
      this.context.dialogs.custom(_react2.default.createElement(_components.ChangePaymentDetailsDialog, null));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var subscription = props.subscription;

      this.setState((0, _extends3.default)({}, this.state, { autoRenew: subscription == undefined ? null : subscription.autoRenew }));
    }
  }, {
    key: 'handleAutoRenewChange',
    value: function handleAutoRenewChange(ev) {
      var dispatch = this.props.dispatch;

      var autoRenew = ev.target.checked;
      this.setState((0, _extends3.default)({}, this.state, { autoRenew: autoRenew }));

      if (autoRenew === true) dispatch((0, _subscriptions.enableSubscriptionAutoRenew)());else dispatch((0, _subscriptions.disableSubscriptionAutoRenew)());
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var styles = require('./UserSubscription.scss');

      var _props = this.props,
          subscription = _props.subscription,
          quota = _props.quota;
      var autoRenew = this.state.autoRenew;


      var sub = subscription == undefined ? _react2.default.createElement('i', { className: 'fa fa-spin fa-refresh fa-fw' }) : subscription.planName;
      var currentQuota = quota == undefined ? _react2.default.createElement('i', { className: 'fa fa-spin fa-refresh fa-fw' }) : quota.currentQuota;
      var billing = subscription == undefined ? null : subscription.billing;
      var paymentMethodString = subscription == undefined ? '' : subscription.paymentMethodString;
      var isActive = subscription == undefined ? null : subscription.isActive;
      var isAutoRenew = subscription && subscription.autoRenew || false;
      var doesGetCharged = subscription && subscription.doesGetCharged || false;
      var isTrial = subscription && subscription.isTrial || false;
      var payment = _react2.default.createElement('i', { className: 'fa fa-spin fa-refresh fa-fw' });
      var expiresAt = subscription.expiresAt;

      var subscription_info_box = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles['subscription-info-box'], true), (0, _defineProperty3.default)(_classnames, styles['subscription-info-box-hide-border'], !((billing == 'monthly' || billing == 'annual') && !!doesGetCharged && !autoRenew)), _classnames));

      return _react2.default.createElement(
        _components.InfoBox,
        { title: 'Your Subscription', icon: '/icons/library.svg' },
        _react2.default.createElement(
          'div',
          { className: subscription_info_box },
          _react2.default.createElement(
            'div',
            { className: styles['subscription-info-title'] },
            _react2.default.createElement(
              'span',
              null,
              sub
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles['subscription-info'] },
            _react2.default.createElement(
              'span',
              null,
              currentQuota
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { textAlign: 'center' } },
            _react2.default.createElement(
              'span',
              null,
              'POINTS'
            )
          ),
          isActive && _react2.default.createElement(
            'div',
            { className: styles['subscription-next-charge'] },
            'Next charge on',
            _react2.default.createElement(
              'strong',
              { className: styles['subscription-next-charge-date'] },
              (0, _moment2.default)(expiresAt).format('MMMM DD, YYYY')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.row },
            isActive && _react2.default.createElement(
              'div',
              { style: { padding: '20px 0 8px 0' } },
              _react2.default.createElement(_components.Button, { primary: true, fullWidth: true, label: 'Top-up points', onClick: this.onTopupClick.bind(this) })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: '' + styles.padding16, style: { overflow: 'auto' } },
          _react2.default.createElement(
            'div',
            { className: styles['col-md-12'] },
            doesGetCharged && _react2.default.createElement(
              'div',
              { className: styles.row },
              _react2.default.createElement(_components.Button, { secondary: true, fullWidth: true, label: 'Payment details', onClick: this.onChangePaymentDetailsClick.bind(this) })
            ),
            isActive && isAutoRenew && _react2.default.createElement(
              'div',
              { className: styles.row },
              _react2.default.createElement(_components.Button, { secondary: true, fullWidth: true, label: 'Cancel Subscription', onClick: this.onCancelSubscriptionClick.bind(this) })
            ),
            isActive && (billing == 'monthly' || billing == 'annual') && !!doesGetCharged && !autoRenew && _react2.default.createElement(
              'div',
              { style: { textAlign: 'center' } },
              _react2.default.createElement(_components.Button, { primary: true, fullWidth: true, label: 'Subscribe', onClick: this.onRestartSubscriptionClick.bind(this) })
            ),
            !isActive && (billing == 'monthly' || billing == 'annual') && !!doesGetCharged && autoRenew && _react2.default.createElement(
              'div',
              { style: { textAlign: 'center' } },
              _react2.default.createElement(_components.Button, { primary: true, fullWidth: true, label: 'Subscribe', onClick: this.onRestartSubscriptionClick.bind(this) })
            )
          )
        )
      );
    }
  }]);
  return UserSubscription;
}(_react2.default.Component), _class.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _temp);
var UserSubscriptionContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    subscription: state.user.subscription,
    quota: state.user.quota
  };
}), _dec(_class2 = function (_React$Component2) {
  (0, _inherits3.default)(UserSubscriptionContainer, _React$Component2);

  function UserSubscriptionContainer() {
    (0, _classCallCheck3.default)(this, UserSubscriptionContainer);
    return (0, _possibleConstructorReturn3.default)(this, (UserSubscriptionContainer.__proto__ || (0, _getPrototypeOf2.default)(UserSubscriptionContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(UserSubscriptionContainer, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          subscription = _props2.subscription,
          quota = _props2.quota,
          dispatch = _props2.dispatch;


      if (!subscription) return null;

      return _react2.default.createElement(UserSubscription, { subscription: subscription, quota: quota, dispatch: dispatch });
    }
  }]);
  return UserSubscriptionContainer;
}(_react2.default.Component)) || _class2);
exports.default = UserSubscriptionContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UserSubscription/UserSubscription.jsx
// module id = 2686
// module chunks = 0